import { Injectable, inject } from '@angular/core';
import { SiteApiService } from '@core/api/site-api.service';
import {
  AppInitializeAction,
  SetSelectedVesselAction,
  SetSystemDatesAction,
} from '@dashboard-store';
import { forkJoin, map, tap } from 'rxjs';
import { GlobalDataService } from '../../../services/global-data.service';
import { SocketsService } from '@core/services/sockets/sockets.service';
import { IVessel } from '@dashboard/models';
import { Store } from '@ngrx/store';
import { StoreInitService } from '@dashboard/dashboard-library/helpers/store-init.service';
import { RoleApiService } from '@core/api/role-api.service';
import { ActivatedRouteSnapshot } from '@angular/router';
import { DashboardDateSyncService } from '@dashboard/services/dashboard-date-sync.service';
import {
  DefaultFromDateRouteParam,
  DefaultToDateRouteParam,
} from '@dashboard/dashboard-store/reducers/ui-state.initial';
import { RouteIds } from '@dashboard/dynamic-dashboards.route';

@Injectable()
export class DynamicDashboardResolverService {
  private RolesApi = inject(RoleApiService);
  private _globalDataService = inject(GlobalDataService);
  private dateSync = inject(DashboardDateSyncService);
  private _globalSockets = inject(SocketsService);

  constructor(
    private _sitesApi: SiteApiService,
    private _storeInitHelper: StoreInitService,
    private _store: Store
  ) {}
  resolve(route: ActivatedRouteSnapshot) {
    this._globalSockets.ensureConnected();

    const Calls = {
      sites: this.getSites(),
      roles: this.RolesApi.getRoles(),
    };

    const to = route.queryParamMap.get('to') ?? DefaultToDateRouteParam();
    const fromRaw = route.queryParamMap.get('from');
    const hasVesselRoute = this.routeTreeContainsParam(route, RouteIds.vesselImo);

    const from = hasVesselRoute
      ? (fromRaw ?? DefaultFromDateRouteParam(to))
      : undefined;

    this.dateSync.setDateRangeFromRouteParams({
      to,
      ...(from ? { from } : {}),
    });
    return forkJoin(Calls).pipe(
      tap(async ({ sites, roles }) => {
        this._globalDataService.$roles.next(roles);
        this.setStoreInitData(sites);
      })
    );
  }

  private routeTreeContainsParam(
    route: ActivatedRouteSnapshot | null,
    param: string
  ): boolean {
    let current = route;

    while (current) {
      if (current.paramMap.has(param)) {
        return true;
      }
      current = current.firstChild;
    }

    return false;
  }

  getSites() {
    return this._sitesApi.getSitesV2().pipe(
      map(({ sites }) => {
        const vissibleVessels = sites.filter((vessel) => !vessel.hidden);
        this._globalDataService.$sites.next(vissibleVessels);
        return vissibleVessels;
      })
    );
  }

  /**
   * Here we are emiting actions in order to populate the store state before component where loaded.
   */
  private setStoreInitData(vessels: IVessel[]) {
    this._storeInitHelper.StoreSetup(vessels);

    this._storeInitHelper.InitalizeMapLayers();
    this._storeInitHelper.InitializeTrace();
    this._store.dispatch(AppInitializeAction());
  }
}
